import { Component, Input } from '@angular/core';
import { DATETIME_FORMAT } from 'src/app/core/constants/date';
import { SystemNotificationFollowUp } from 'src/app/core/models/system-notification-message';

@Component({
  selector: 'th-follow-up-datatable',
  templateUrl: './follow-up-datatable.component.html',
  styleUrls: ['./follow-up-datatable.component.scss']
})
export class FollowUpDatatableComponent {
  @Input() followUpRows: SystemNotificationFollowUp[];
  protected readonly dateFormat = DATETIME_FORMAT;
}
